// extracted by mini-css-extract-plugin
export default {"dashboard_container":"dashboard_container___BxrZL","scroll_bar":"scroll_bar___fe0QB","navbar":"navbar___cDr4B","navbar_browserai":"navbar_browserai___ZuQaE"};